import {HStack} from 'platform/foundation-tw';
import {cva} from 'platform/shared-tw';

import type {MiraType} from '../../types';
import {MiraIcon} from '../MiraIcon/MiraIcon';

const VARIANT_ICON_MAP: Record<MiraType, 'mira/damage' | 'mira/service' | 'mira/suggestions'> = {
  damage: 'mira/damage',
  service: 'mira/service',
  suggestions: 'mira/suggestions',
};

const badgeVariants = cva('box-border rounded-full py-2 pr-4 pl-3', {
  variants: {
    type: {
      damage: 'mira-type-damage bg-[var(--mira-bg)]',
      service: 'mira-type-service bg-[var(--mira-bg)]',
      suggestions: 'mira-type-suggestions bg-[var(--mira-bg)]',
    },
  },
});

const textVariants = cva('text-lg font-medium leading-6 shrink-0 whitespace-nowrap tabular-nums', {
  variants: {
    type: {
      damage: 'text-[var(--mira-text)]',
      service: 'text-[var(--mira-text)]',
      suggestions: 'text-[var(--mira-text)]',
    },
  },
});

const iconVariants = cva('flex items-center justify-center size-6 shrink-0', {
  variants: {
    type: {
      damage: 'text-[var(--mira-stroke)]',
      service: 'text-[var(--mira-stroke)]',
      suggestions: 'text-[var(--mira-stroke)]',
    },
  },
});

export interface MainBadgeProps {
  readonly type: MiraType;
  readonly count: number;
}

/**
 * MAINBADGE
 * Displays a badge with an icon and count for different Mira types
 *
 * @prop type - The type of badge (damage, service, suggestions)
 * @prop count - Number to display in the badge
 */
export function MainBadge(props: MainBadgeProps) {
  const iconName = VARIANT_ICON_MAP[props.type];

  return (
    <div className={badgeVariants({type: props.type})}>
      <HStack spacing={2} align="center">
        <span className={iconVariants({type: props.type})}>
          <MiraIcon name={iconName} />
        </span>
        <span className={textVariants({type: props.type})}>{props.count}</span>
      </HStack>
    </div>
  );
}
